import requestFunctions from "../../functions/requestFunctions";


export const state = {
  PHONES_CODES_ITEM: {},
  PHONES_CODES_LIST: [],
  PHONES_CODES_TABLE_DATA: [],
  PHONES_CODES_LIST_DATA: [],
  PHONES_CODES_TOTAL_ROWS: 0
}

export const getters = {
  GET_PHONES_CODES_ITEM: (state) => {
    return state.PHONES_CODES_ITEM;
  },
  GET_PHONES_CODES_LIST_DATA: (state) => {
    return state.PHONES_CODES_LIST_DATA;
  },
  GET_PHONES_CODES_TABLE_DATA: (state) => {
    return state.PHONES_CODES_TABLE_DATA;
  },
  GET_PHONES_CODES_TOTAL_ROWS: (state) => {
    return state.PHONES_CODES_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_PHONES_CODES_ITEM(state, item) {
    state.PHONES_CODES_ITEM = item;
  },
  UPDATE_PHONES_CODES_LIST(state, list) {

    state.PHONES_CODES_LIST = list.data;
    state.PHONES_CODES_TOTAL_ROWS = list.total;

    list = list.data;

    state.PHONES_CODES_TABLE_DATA = [];
    state.PHONES_CODES_LIST_DATA = [];

    list.forEach(el => {

      state.PHONES_CODES_TABLE_DATA.push({
        'id'   : el.id ? el.id : null,
        'uuid' : el.uuid ? el.uuid : null,
        'code': el.code ? el.code : null,
        'from_phone': el.from_phone ? el.from_phone : null,
        'until_phone': el.until_phone ? el.until_phone : null,
        'c': el.c ? el.c : null,
        'provider': el.provider ? el.provider : null,
        'region_name': el.region_name ? el.region_name : null,
        'region_name': el.region_name ? el.region_name : null,
        'region_utc': el.region_utc ? el.region_utc : null,
        'country_name': el.country_name ? el.country_name : null,

      });

      state.PHONES_CODES_LIST_DATA.push({
        'id'   : el.id   ? el.id   : null,
        'uuid' : el.uuid ? el.uuid : null,
        'code': el.code ? el.code : null,
        'from_phone': el.from_phone ? el.from_phone : null,
        'until_phone': el.until_phone ? el.until_phone : null,
        'c': el.c ? el.c : null,
        'provider': el.provider ? el.provider : null,
        'region_name': el.region_name ? el.region_name : null,
        'region_name': el.region_name ? el.region_name : null,
        'region_utc': el.region_utc ? el.region_utc : null,
        'country_name': el.country_name ? el.country_name : null,

      });

    });
  },
}


export const actions = {

  async FETCH_PHONES_CODES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/phones/codes/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PHONES_CODES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_PHONES_CODES_LIST({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/phones/codes';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PHONES_CODES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_PHONES_CODES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/phones/codes';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_PHONES_CODES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/phones/codes/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_PHONES_CODES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/phones/codes/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}